<template>
  <div>
    <div
      v-if="!inviteStatus.isUserLoggedIn"
      class="text-center"
    >
      <h1
        v-t="'JOIN_INVITE_SUCCESS'"
        class="title md-title"
      />
      <p
        v-t="'JOIN_INVITE_SUCCESS_SUBHEADER'"
        class="subtitle"
      />
      <a
        v-t="'BACK_LOGIN_LINK'"
        href="#"
        class="button button--transparent-grad pulse m-t-20"
        @click="goToLogin"
      />
    </div>
    <div
      v-if="inviteStatus.isUserLoggedIn"
      class="text-center"
    >
      <h1
        v-t="'JOIN_INVITE_SUCCESS'"
        class="title md-title"
      />
      <p
        v-t="'JOIN_INVITE_SUCCESS_LOGGED_SUBHEADER'"
        class="subtitle"
      />
      <a
        v-t="'BACK_DASHBOARD_LINK'"
        href="#"
        class="button button--transparent-grad pulse m-t-20"
        @click="goToDashboard"
      />
    </div>
  </div>
</template>

<script>
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import messages from '../locales';

export default {
  props: {
    inviteStatus: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    goToLogin() {
      $ngStateService.go('login');
    },
    goToDashboard() {
      $ngStateService.go('dashboard.main');
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>

</style>